import Price from "components/Price/Price"
import _ from "lodash"
import React, { Fragment } from "react"
import { Component } from "react"
import { Link, NavLink } from "react-router-dom"
import { Button , Message, Container} from "semantic-ui-react"
import shop from "shop/shop"
import ordinals from "theme/arnoldsports/sortParamsVariant"

export default class Variants extends Component {

  state = {
    selectedArt: false,
    artikelart: false,
    groesse: false,
    fakevariants: false,
    variantsTemp: {}
  }

  selectType = ( selectedArt ) => {
    this.setState( { selectedArt } )
    this.setState({artikelart : false})
  }

 componentWillReceiveProps( props ) {
    const { selectByField = "variante2" } = props
    if ( props.product !== this.props.product || props.byAttribute && !this.state.selectedArt ) {
      if ( props.product ) {
        this.selectType( props.product.extraValue[ selectByField ] )
      }
      else {
        this.selectType( _.keys( props.byAttribute[ selectByField ] )[ 0 ] )
      }
    }
  }

  render() {
    const { byAttribute, product } = this.props
    const {selectedArt,artikelart,groesse,variantsTemp} = this.state
    
    if ( !byAttribute ) return null
    const pinnedAttr = {}
    //console.log('Attributes: ',byAttribute);
    
    if ( !shop.config.variantNames && !this.state.fakevariants) {
      shop.config.fakevariantNames = []
      shop.config.fakevariantNames[0] = "variante1"
      shop.config.fakevariantNames[1] = "variante2"
      this.setState({fakevariants : true})

      shop.config.fakevariantNames.map( variantKey => {
        const variants = byAttribute[ variantKey ]
        const pinned = { ...pinnedAttr }
        delete pinned[ variantKey ]
        console.log("this.props variantNames:",variantKey)
        let variantKeys = _.keys( variants )
         // TODO: UNIFY
        console.log("this.props variantKeys:",variantKeys)
        const keys = variantKeys.sort( ( a, b ) => {
          let s0 = ordinals[ a ]
          let s1 = ordinals[ b ]
            if(!s0 && !s1){
                if(a && b){
                  console.log("this.props a, b",a," ",b)
                  let a_temp = a.split(" ");
                  let b_temp = b.split(" ");
                  console.log("this.props a, b",a_temp[0]," ",b_temp[0])
                  if(a_temp[0] >= b_temp[0]){
                    console.log("this.props a_temp größer")
                  }
                  if(b_temp[0] >= a_temp[0]){
                    console.log("this.props b_temp größer")
                  }
                  console.log("this.props returnvalue ", Number(a_temp[0]) >= Number(b_temp[0]) ? 1: -1)
                  return Number(a_temp[0]) >= Number(b_temp[0]) ? 1: -1
                }
                return Number(a) >= Number(b) ? 1: -1
            }
          return s0 >= s1 ? 1 : -1
        } )
        console.log("this.props variants LOG:",variants)
        //var res = Object.keys(variants).reduce((prev, curr, index) => { console.log("this.props res",variants[curr][0]); return {...prev, [variants[curr]]: variants[curr]}}, {});
        variantKeys = keys

        this.setState({variantsTemp: variantKeys})
        console.log("this.props variantKeys:",variantsTemp)
       if ( !keys || keys.length <= 1 ) return null

      
    })
  }
    if ( shop.config.variantNames && !this.state.fakevariants) {
      console.log("this.props :",shop.config.variantNames)
      shop.config.variantNames.forEach( variantKey => {
        pinnedAttr[ variantKey ] = product.extraValue[ variantKey ]
      } )
      return (
        <div>
          {shop.config.variantNames.map( variantKey => {
            const variants = byAttribute[ variantKey ]
            const pinned = { ...pinnedAttr }
            delete pinned[ variantKey ]

            const variantKeys = _.keys( variants )
             // TODO: UNIFY
            const keys = variantKeys.sort( ( a, b ) => {
              let s0 = ordinals[ a ]
              let s1 = ordinals[ b ]
              console.log("this.props s0, s1",s0," ",s1)
                if(!s0 && !s1){
                    return Number(a) >= Number(b) ? 1: -1
                }
              return s0 >= s1 ? 1 : -1
            } )
           if ( !keys || keys.length <= 1 ) return null


            const selected = product.extraValue[ variantKey ]
            return <div className="variant-group pb3" key={variantKey}>
              <h4>{translate( variantKey )}</h4>
              {
                _.map( keys, ( key ) => {
                  let items = variants[ key ]
                  let item = _.first( items.filter( p => {
                    let hit = false
                    _.forEach( pinned, ( value, key ) => {
                      hit = hit || p.extraValue[ key ] === value
                    } )
                    return hit
                  } ) )
                  if ( !item ) {
                    item = items[ 0 ]
                  }
                  return <Button size="tiny"
                                 as={Link}
                                 className={`button-variant ${selected === item.extraValue[ variantKey ] ? "selected" : null} `}
                                 to={{ pathname: `/product/${item.map_id}/`, state: { preventScrollToTop: true } }} key={key}
                                 onClick={() => this.selectType( key )}
                                 basic>{translate( key )}</Button>
                } )
              }
            </div>
          } )}
        </div>
      )
    }

    return (
      <div>
        
        <table>
        <colgroup>
					<col width="50%" />
					<col width="50%" />
				</colgroup>
          <td onMouseLeave={() => this.setState( {artikelart: false} )} style={{alignContent: "center"}}>
          {byAttribute.variante2 &&
        <div>
          {<Button large className="variantsButtonLudden pa1" onMouseEnter={() => this.setState( {artikelart: true} )}
          
          primary onClick={() => this.setState( {artikelart: true} )}  >
            1. Variantenmerkmal</Button>}
          {artikelart && <Container style={{ padding: 0 , width: "220px", alignContent: "center"}} 
          className="absolute bg-white w-100 z-999 animate fadeIn variantsContainer" ><div style={{ alignContent: "center"}}  className="justify-between bg-black-10 pa3 VariantsPullDown">
          { 
          _.map( _.keys( byAttribute.variante2 ), ( key ) => {
            let items = byAttribute.variante2[ key ] ||[]
            let item = items[ 0 ]
            console.log("this.props item: ", key)
            items.forEach(i => {
              if(i.extraValue.variante1 === product.extraValue.variante1) item = i
            })
            console.log( selectedArt, item.extraValue.variante2 )
            return <Fragment><Button size="tiny" as={NavLink} 
            style={{ alignContent: "center"}} 
                           activeClassName="selected"
                           className={`button-variant2 ${selectedArt === item.extraValue.variante2 ? "selected" : null} `}
                           to={{ pathname: `/product/${item.map_id}`, state: { preventScrollToTop: true } }} key={key}
                           onClick={() => this.selectType( key )}
                           primary>{translate( key )}</Button><br/></Fragment>
          } )}</div></Container>}
        </div>}
          </td>
          <td onMouseLeave={() => this.setState( {groesse: false} )} style={{alignContent: "center"}}>
          {<Button large className="variantsButtonLudden pa1" onMouseEnter={() => this.setState( {groesse: true} )}
          primary onClick={() => this.setState( {groesse: true} )} >
          2. Variantenmerkmal</Button>}
          {groesse && <Container style={{ padding: 0 , width: "220px", alignContent: "center", backgroundColor: "white"}} 
          className="absolute bg-white w-100 z-999 animate fadeIn variantsContainer" ><div style={{ alignContent: "center"}}  className="justify-between bg-black-10 pa3 VariantsPullDown">
          
        {_.map( byAttribute.variante1, ( items ) => { 
          console.log("this.props Variante Größe", items)
          return items
            .filter( p => p.extraValue.variante2 === selectedArt )
            
            .map( item => {
              //console.log("this.props Variante Größe", item)
              return <Button key={item.map_id} className="tl button-variant3" primary size="tiny"  as={NavLink}
                             activeClassName="selected"
                             onClick={() => this.setState({groesse: false})}
                             to={{
                               pathname: `/product/${item.map_id}`,
                               state:    { preventScrollToTop: true }
                             }}><span className="center ">{item.extraValue.variante1}</span>
                <br/>{/*<Price className="">{item.price}</Price>*/}</Button>
            } )
        } )}</div></Container>}
          </td>
        </table>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/theme/braunsheitmannShop/components/Variants/Variants.js